import request from '../utils/request'

export default {
  async list (data) {
    const ret = await request('/v1/deviceLog/list', data, 'POST')
    return ret
  }
}
